/**
 * MUI Palette Override
 * @see https://mui.com/material-ui/customization/palette/
 */
const palette = {
  primary: {
    main: '#ED9C00',
    contrastText: '#fff',
  },
  secondary: {
    main: '#ED9C0080',
    contrastText: '#fff',
  },
  success: {
    main: '#70A37F',
    contrastText: '#fff',
  },
  error: {
    main: '#FE6D73',
    contrastText: '#fff',
  },
  warning: {
    main: '#F3C969',
    contrastText: '#fff',
  },
  info: {
    main: '#9DD1F1',
    contrastText: '#fff',
  },
  transparent: {
    main: '#fff',
    dark: '#888',
  },
  divider: 'rgba(0,0,0,0.05)',
};

export default palette;
